"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Angular", {
  enumerable: true,
  get: function () {
    return _angular.Angular;
  }
});
Object.defineProperty(exports, "CaptureConsole", {
  enumerable: true,
  get: function () {
    return _captureconsole.CaptureConsole;
  }
});
Object.defineProperty(exports, "Debug", {
  enumerable: true,
  get: function () {
    return _debug.Debug;
  }
});
Object.defineProperty(exports, "Dedupe", {
  enumerable: true,
  get: function () {
    return _dedupe.Dedupe;
  }
});
Object.defineProperty(exports, "Ember", {
  enumerable: true,
  get: function () {
    return _ember.Ember;
  }
});
Object.defineProperty(exports, "ExtraErrorData", {
  enumerable: true,
  get: function () {
    return _extraerrordata.ExtraErrorData;
  }
});
Object.defineProperty(exports, "Offline", {
  enumerable: true,
  get: function () {
    return _offline.Offline;
  }
});
Object.defineProperty(exports, "ReportingObserver", {
  enumerable: true,
  get: function () {
    return _reportingobserver.ReportingObserver;
  }
});
Object.defineProperty(exports, "RewriteFrames", {
  enumerable: true,
  get: function () {
    return _rewriteframes.RewriteFrames;
  }
});
Object.defineProperty(exports, "SessionTiming", {
  enumerable: true,
  get: function () {
    return _sessiontiming.SessionTiming;
  }
});
Object.defineProperty(exports, "Transaction", {
  enumerable: true,
  get: function () {
    return _transaction.Transaction;
  }
});
Object.defineProperty(exports, "Vue", {
  enumerable: true,
  get: function () {
    return _vue.Vue;
  }
});

var _angular = require("./angular");

var _captureconsole = require("./captureconsole");

var _debug = require("./debug");

var _dedupe = require("./dedupe");

var _ember = require("./ember");

var _extraerrordata = require("./extraerrordata");

var _offline = require("./offline");

var _reportingobserver = require("./reportingobserver");

var _rewriteframes = require("./rewriteframes");

var _sessiontiming = require("./sessiontiming");

var _transaction = require("./transaction");

var _vue = require("./vue");